import { Translation } from 'hooks/useTranslation/useTranslation';
import { PageTabItems } from 'v2/components/PageTabs/PageTabs';

export const createVisitsTabs = (translation: Translation): PageTabItems => [
  {
    text: translation.upcoming,
    path: '/visits/upcoming'
  },
  {
    text: translation.past,
    path: '/visits/past'
  },
  {
    text: translation.cancelled,
    path: '/visits/cancelled'
  }
];
